import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { PainPoint } from './components/PainPoint';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { Testimonials } from './components/Testimonials';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900 selection:bg-red-200 selection:text-red-900" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Navbar data-id="element-2" />
      <main data-id="element-3">
        <Hero data-id="element-4" />
        <PainPoint data-id="element-5" />
        <Services data-id="element-6" />
        <WhyChooseUs data-id="element-7" />
        <Testimonials data-id="element-8" />
        <CTASection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}